// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5253":"ac5676f8","8055":"ac5676f8"}[chunkId] + ".chunk.css";
};